import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Divider, Flex, Image, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IMG_URL } from "./common/Constant";
const PartyGuide = ({ onClose, isOpen = true }) => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(isOpen);
    const onModalClose = () => {
        onClose ? onClose() : setIsModalOpen(false);
        goBack();
    };
    const goBack = () => {
        if (!window.history || window.history.length <= 1) {
            navigate("/home");
        }
        else {
            navigate(-1);
        }
    };
    return (_jsxs(Modal, { onClose: onModalClose, size: "full", isOpen: isModalOpen, motionPreset: "slideInRight", children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { bg: "#111111", color: "white", children: [_jsxs(Flex, { mt: 4, w: "100%", px: 4, alignItems: "center", children: [_jsx(ArrowBackIcon, { fontSize: "2xl", cursor: "pointer", onClick: onModalClose }), _jsx(ModalHeader, { w: "100%", whiteSpace: "nowrap", children: "Zillout Party Guide" })] }), _jsxs(ModalBody, { mt: 4, children: [_jsx(Box, { w: "100%", h: "fit-content", children: _jsx(Image, { src: `${IMG_URL}/icons/party.svg`, w: "100%" }) }), _jsx(Text, { fontSize: "sm", fontWeight: 600, mt: 8, children: "Cover Charge" }), _jsx(Text, { fontSize: "sm", fontWeight: 400, mt: 1, children: "Cover charge can be redeemed usually for drinks & food inside the pub." }), _jsx(Divider, { borderColor: "#383838", my: 6 }), _jsx(Text, { fontSize: "sm", fontWeight: 600, children: "Entry Charge" }), _jsx(Text, { fontSize: "sm", fontWeight: 400, mt: 1, children: "Entry Charge is a fee that you pay to get entry into a venue. This cannot be redeemed inside." })] })] })] }));
};
export default PartyGuide;
